import React, { useEffect, useCallback, useState} from 'react';
import {setKeyboardContext} from 'actions/index.js';
import GroupTracker from "components/mix/mix2/GroupTracker.js"
import {connect} from 'react-redux';
import '../../tracker.scss';

const ZTracker = ({zobject, setKeyboardContext}) => { 
    let subSequence = zobject.subSequence;
    if (subSequence.getRootSubSequence) {
        subSequence = subSequence.getRootSubSequence();
    }
    return (
        <div
          onMouseEnter={() => setKeyboardContext(zobject)}
          onClick={() => setKeyboardContext(zobject)}
             className="z-tracker">
          <GroupTracker group={subSequence}/>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setKeyboardContext: x => dispatch(setKeyboardContext(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZTracker);
